import { Component, OnInit, HostListener } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Services/generalservice.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    classApplied = false;
    LoginDetails: any;
    rgid: any;
    isRecruiter: boolean = false;
    userDetails1: any;// Set to true if user is a recruiter


    // Add these properties after your existing properties
    showChangePasswordModal = false;
    currentPassword = '';
    newPassword = '';
    passwordError = '';
    arr3: any[] = [];


    showNewPassword = false;
    activeTab: any;


    constructor(private viewportScroller: ViewportScroller, private router: Router, public generalService: GeneralService, private route: ActivatedRoute) {
        debugger
        //this.LoginDetails = JSON.parse(localStorage.getItem('LoginDetails'));
        //this.userDetails1 = JSON.parse(localStorage.getItem('userDetails'));
        //if (this.LoginDetails) {
        //    this.rgid = this.LoginDetails[0].RID

        //} else {
        //    this.userDetails1 = JSON.parse(localStorage.getItem('userDetails'));

        //}

        // Listen for query params
        //this.route.queryParams.subscribe(params => {
        //    if (params['tab']) {
        //        this.activeTab = params['tab'];
        //    }
        //});

    }

    //setActiveTab(tab: string) {
    //    this.activeTab = tab;
    //}


    isMenuOpen = false;
    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])

    public onClick(elementId: string): void {
        this.viewportScroller.scrollToAnchor(elementId);
    }


    toggleClass1() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    navigate(link: string) {
        this.router.navigate([link]);
        this.classApplied = false; // Close the menu after navigation
    }
    ngOnInit() {
        this.userDetails1 = JSON.parse(localStorage.getItem('userDetails') || 'null');
        this.LoginDetails = JSON.parse(localStorage.getItem('LoginDetails') || 'null');

        if (this.LoginDetails && !Array.isArray(this.LoginDetails)) {
            this.LoginDetails = [this.LoginDetails]; // Ensure it's an array
        }

        this.rgid = localStorage.getItem('rgid'); // Optional: for dropdown
    }
    home() {
        debugger
        if (!this.userDetails1 && !this.LoginDetails) {
            this.router.navigate([''])
        }
        else if (this.userDetails1.RoleId==3) {
          
            this.router.navigate([''])
        }
        else if (this.LoginDetails[0].RoleId==2) {
           
            this.router.navigate(['/company-account'])
        }
    }
    //Logout() {
    //    if (this.LoginDetails) {
    //        localStorage.removeItem('LoginDetails');
    //        localStorage.removeItem('userDetails');

    //        this.router.navigate(['']).then(() => {
    //            window.location.reload();
    //        })
    //    }
    //    else if (this.userDetails1) {
    //        localStorage.clear();
    //        this.router.navigate(['']).then(() => {
    //        window.location.reload();
    //        });
    //    }
                
    //}

    Logout() {
        localStorage.clear();
        this.router.navigate(['']).then(() => {
            window.location.reload();
        });
    }

    Logout1() {
        if (this.LoginDetails) {
            localStorage.removeItem('LoginDetails');

            this.router.navigate(['']).then(() => {
                window.location.reload();
            })
        }
        else if (this.userDetails1) {
            localStorage.clear();
            this.router.navigate(['']).then(() => {
                window.location.reload();
            });
        }


    }
    //toggleClass() {
    //    this.classApplied = !this.classApplied;
    //}


  


    toggleClass() {
        this.classApplied = !this.classApplied;  
        this.isMenuOpen = !this.isMenuOpen;
        //if (this.classApplied) {
        //    setTimeout(() => {
        //        this.classApplied = false; 
        //    }, 1500);  
        //}
    }
    closeMenu() {
        this.isMenuOpen = false;
    }

    login() {
        
        this.router.navigate(['/Login']);
    }

    Registration() {
        
        this.router.navigate(['/Registration']);
    }

    Recuterlogin() {
        this.router.navigate(['/recuiter-login']);
    }

    manageaccount() {
        this.router.navigate(['/useraccount']);
    }

    AppliedJobs() {
        this.router.navigate(['/appliedjobs']);
    }



    // Replace your existing ChangePassword method with this:
    ChangePassword() {
        this.showChangePasswordModal = true;
        this.currentPassword = '';
        this.newPassword = '';
        this.passwordError = '';
    }

    // Add these new methods:
    closePasswordModal() {
        this.showChangePasswordModal = false;
        this.currentPassword = '';
        this.newPassword = '';
        this.passwordError = '';
    }

    validateAndUpdatePassword() {
        if (this.currentPassword !== this.userDetails1.Password) {
            this.passwordError = 'Current password is incorrect';
            return;
        }

        if (this.newPassword.length < 6) {
            this.passwordError = 'New password must be at least 6 characters';
            return;
        }

        this.updatePassword();
    }

    updatePassword() {
        this.arr3 = [];
        this.arr3.push({
            RegId: this.rgid || this.userDetails1.RegId,
            Password: this.newPassword,
        });

        var formdata = new FormData();
        formdata.append("Param", JSON.stringify(this.arr3));
        formdata.append("flag", '11');
        var url = "api/Njobs/Crud_Jobsekar_Registration";

        this.generalService.PostData(url, formdata).then(data => {
            if (data == 'SUCCESS') {
                this.generalService.ShowAlert("SUCCESS", 'Password updated successfully', 'success');
                this.closePasswordModal();
                // Update local storage
                if (this.userDetails1) {
                    this.userDetails1.Password = this.newPassword;
                    localStorage.setItem('userDetails', JSON.stringify(this.userDetails1));
                    this.Logout();
                }
            } else {
                this.generalService.ShowAlert("ERROR", 'Something went wrong', 'error');
            }
        }).catch(error => {
            this.generalService.ShowAlert("ERROR", 'Something went wrong', 'error');
        });
    }






    toggleNewPasswordVisibility() {
        this.showNewPassword = !this.showNewPassword;
    }






}
